// removed by extract-text-webpack-plugin
module.exports = {"logo-icon":"_2UVAQ","logoIcon":"_2UVAQ","logo":"_1JQgh","hide":"_18myF"};